module.exports = __webpack_public_path__ + "media/src/img/payment/Frame6-3cf7cc8567346aab44c87f969df7e74e.svg";